import { Category } from "constants/events";

import DeliveryValidation from "components/DeliveryGateway/DeliveryValidation";
import Image from "components/Image";
import TrackImpression from "components/TrackImpression";

const DeliveryGatewayHero: React.FC = () => {
  return (
    <>
      <TrackImpression
        category={Category.deliveryGateFlow}
        label="hero image block"
      >
        <section className="hero relative">
          <div className="container flex flex-col justify-center z-10 relative">
            <div className="grid grid-rows-3 gap-0.5 md:gap-2">
              <h1 className="flex flex-col justify-center items-center text-xxl md:flex-row md:mr-sm">
                <span className="mr-sm">All the weed,</span>
                <span className="text-xxl">delivered.</span>
              </h1>
              <span className="flex flex-col text-sm font-bold md:justify-center items-center md:items-start md:flex-row ">
                <span className="md:mr-xs">Shop, order, hang tight.</span>
                <span>We’ll arrange the rest.</span>
              </span>
              <div className="flex justify-center w-full">
                <DeliveryValidation
                  trackingCategory={Category.deliveryGateFlow}
                  trackingLabel="hero image block"
                />
              </div>
            </div>
          </div>
          <Image
            alt=""
            background={true}
            disableLazyLoad
            mobileSrc="https://leafly-public.imgix.net/web-web/delivery-gateway-hero-mobile.jpg"
            sizes={[544, 767, 1023, 1440, null, 767]}
            src="https://leafly-public.imgix.net/web-web/delivery-gateway-hero-desktop.jpg"
          />
        </section>
      </TrackImpression>
      <style jsx>{`
        .hero {
          padding: 90px 0 270px 0;
        }

        @media (min-width: 768px) {
          .hero {
            padding-bottom: 170px;
          }
        }
      `}</style>
    </>
  );
};
export default DeliveryGatewayHero;
